

import {computed, onMounted, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import {FilterMatchMode} from "primevue/api";
import moment from "moment";
import theoDoiRepository from "@/services/TheoDoiRepository";
import {TinhTien} from "@/models/tinhTien";
import {DieuTri} from "@/models/dieuTri";
import {values} from "lodash";
import { DoanhThu } from '@/models/doanhThu';
import {DoanhThuCungKy} from "@/models/doanhThuCungKy";
import {Dashboard} from "@/models/dashboard";
import {DashboardDT} from "@/models/dashboardDT";
import {DashboardDV} from "@/models/dashboardDV";


export default {
  setup: function () {
    const toast = useToast();
    const date = ref();
    const dashboardDT = ref([] as DashboardDT[]);
    const dashboardDV = ref([] as DashboardDV[]);
    const noiTru = ref(0);
    const dieuTriNoiTru = ref(0);
    const tongDienCham = ref(0);
    const tongCayChi = ref(0);
    const tongGiacHoi = ref(0);
    const tongXoaBop = ref(0);
    const tongSacThuoc = ref(0);
    const tongXongHoi = ref(0);
    const tongCongYHCT = ref(0);
    const tongDienXung = ref(0);
    const tongSieuAm = ref(0);
    const tongHongNgoai = ref(0);
    const tongTap = ref(0);
    const tongKtXoaBopVung = ref(0);
    const tongOxy = ref(0);
    const tongCongPHCN = ref(0);
    const tempDV = ref({} as DashboardDV);
    const tongTienCD = ref(0);
    const tongTienTH = ref(0);
    const tongTienPHCN = ref(0);
    const tongTienCLS = ref(0);

    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null)) {
        theoDoiRepository.dashboardDT(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              dashboardDT.value = response.data;
              noiTru.value = 0;
              dieuTriNoiTru.value = 0;
              dashboardDT.value.forEach(x => {
                if((x.phongBan_Id != 66)&&(x.phongBan_Id != 69))
                {
                  noiTru.value = noiTru.value + x.dangDT;
                }
                else {
                  dieuTriNoiTru.value = dieuTriNoiTru.value + x.dangDT;
                }
                if (x.phongBan_Id == 8) {
                  x.phongBan = "Phòng Khám CS1";
                }
                if (x.phongBan_Id == 28) {
                  x.phongBan = "Khoa NTH";
                }
                if (x.phongBan_Id == 146) {
                  x.phongBan = "Khoa Lão";
                }
                if (x.phongBan_Id == 164) {
                  x.phongBan = "Khoa CSGN";
                }
                if (x.phongBan_Id == 66) {
                  x.phongBan = "Khoa CCDS";
                }
                if (x.phongBan_Id == 69) {
                  x.phongBan = "Khoa CCDS CS2";
                }
                tongTienCD.value = 0;
                tongTienTH.value = 0;
                tongTienPHCN.value = 0;
                tongTienCLS.value = 0;
                dashboardDT.value.forEach(x => {
                  tongTienCD.value = tongTienCD.value + x.tongTienChiDinh;
                  tongTienTH.value = tongTienTH.value + x.tongTienThucHien;
                  tongTienPHCN.value = tongTienPHCN.value + x.tongTienPHCN;
                  tongTienCLS.value = tongTienCLS.value + x.tongTienCLS;
                })
              })
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
        theoDoiRepository.dashboardDV(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              dashboardDV.value = response.data;
              if(dashboardDV.value.length > 0)
              {
                const index = ref(0);
                dashboardDV.value.forEach(x => {
                  if(x.dienCham > index.value){
                    index.value = x.dienCham;
                  }
                });
                tempDV.value.dienCham = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.cayChi > index.value){
                    index.value = x.cayChi;
                  }
                });
                tempDV.value.cayChi = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.giacHoi > index.value){
                    index.value = x.giacHoi;
                  }
                });
                tempDV.value.giacHoi = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.xoaBop > index.value){
                    index.value = x.xoaBop;
                  }
                });
                tempDV.value.xoaBop = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.sacThuoc > index.value){
                    index.value = x.sacThuoc;
                  }
                });
                tempDV.value.sacThuoc = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.xongHoi > index.value){
                    index.value = x.xongHoi;
                  }
                });
                tempDV.value.xongHoi = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.tongYHCT > index.value){
                    index.value = x.tongYHCT;
                  }
                });
                tempDV.value.tongYHCT = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.dienXung > index.value){
                    index.value = x.dienXung;
                  }
                });
                tempDV.value.dienXung = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.sieuAm > index.value){
                    index.value = x.sieuAm;
                  }
                });
                tempDV.value.sieuAm = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.hongNgoai > index.value){
                    index.value = x.hongNgoai;
                  }
                });
                tempDV.value.hongNgoai = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.tap > index.value){
                    index.value = x.tap;
                  }
                });
                tempDV.value.tap = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.ktXoaBopVung > index.value){
                    index.value = x.ktXoaBopVung;
                  }
                });
                tempDV.value.ktXoaBopVung = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.oxy > index.value){
                    index.value = x.oxy;
                  }
                });
                tempDV.value.oxy = index.value;
                index.value = 0;
                dashboardDV.value.forEach(x => {
                  if(x.tongPHCN > index.value){
                    index.value = x.tongPHCN;
                  }
                });
                tempDV.value.tongPHCN = index.value;
              }
              tongDienCham.value = 0;
              tongCayChi.value = 0;
              tongGiacHoi.value = 0;
              tongXoaBop.value = 0;
              tongSacThuoc.value = 0;
              tongXongHoi.value = 0;
              tongCongYHCT.value = 0;
              tongDienXung.value = 0;
              tongSieuAm.value = 0;
              tongHongNgoai.value = 0;
              tongTap.value = 0;
              tongKtXoaBopVung.value = 0;
              tongOxy.value = 0;
              tongCongPHCN.value = 0;
              dashboardDV.value.forEach(x => {
                if (x.phongBan_Id == 8) {
                  x.phongBan = "Phòng Khám CS1";
                }
                if (x.phongBan_Id == 28) {
                  x.phongBan = "Khoa NTH";
                }
                if (x.phongBan_Id == 146) {
                  x.phongBan = "Khoa Lão";
                }
                if (x.phongBan_Id == 164) {
                  x.phongBan = "Khoa CSGN";
                }
                if (x.phongBan_Id == 66) {
                  x.phongBan = "Khoa CCDS";
                }
                if (x.phongBan_Id == 69) {
                  x.phongBan = "Khoa CCDS CS2";
                }
              })

              dashboardDV.value.forEach(x => {
                tongDienCham.value = tongDienCham.value + x.dienCham;
                tongCayChi.value = tongCayChi.value + x.cayChi;
                tongGiacHoi.value = tongGiacHoi.value + x.giacHoi;
                tongXoaBop.value = tongXoaBop.value + x.xoaBop;
                tongSacThuoc.value = tongSacThuoc.value + x.sacThuoc;
                tongXongHoi.value = tongXongHoi.value + x.xongHoi;
                tongCongYHCT.value = tongCongYHCT.value + x.tongYHCT;
                tongDienXung.value = tongDienXung.value + x.dienXung;
                tongSieuAm.value = tongSieuAm.value + x.sieuAm;
                tongHongNgoai.value = tongHongNgoai.value + x.hongNgoai;
                tongTap.value = tongTap.value + x.tap;
                tongKtXoaBopVung.value = tongKtXoaBopVung.value + x.ktXoaBopVung;
                tongOxy.value = tongOxy.value + x.oxy;
                tongCongPHCN.value = tongCongPHCN.value + x.tongPHCN;
              })
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            })
      }
      };

    const clearCalendar = () => {
      dashboardDT.value = [];
      dashboardDV.value = [];
      // loadData();
    }
    const convertMoney =  (val) => {
      return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2, style: 'currency', currency: 'VND' }).format(val);
    }
    const findIndex = (id, val) => {
      if(val == 0 ) false;
      else
      {
        if (id == 1) {
          if (val == tempDV.value.dienCham) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 2) {
          if (val == tempDV.value.cayChi) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 3) {
          if (val == tempDV.value.giacHoi) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 4) {
          if (val == tempDV.value.xoaBop) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 5) {
          if (val == tempDV.value.sacThuoc) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 6) {
          if (val == tempDV.value.xongHoi) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 7) {
          if (val == tempDV.value.tongYHCT) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 8) {
          if (val == tempDV.value.dienXung) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 9) {
          if (val == tempDV.value.sieuAm) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 10) {
          if (val == tempDV.value.hongNgoai) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 11) {
          if (val == tempDV.value.tap) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 12) {
          if (val == tempDV.value.ktXoaBopVung) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 13) {
          if (val == tempDV.value.oxy) {
            return true;
          } else {
            return false;
          }
        }
        else if (id == 14) {
          if (val == tempDV.value.tongPHCN) {
            return true;
          } else {
            return false;
          }
        }
      }
    }

    return {
      date,
      dashboardDV,
      dashboardDT,
      selectCalendar,
      clearCalendar,
      noiTru,
      dieuTriNoiTru,
      tongDienCham,
      tongCayChi,
      tongGiacHoi,
      tongXoaBop,
      tongSacThuoc,
      tongXongHoi,
      tongCongYHCT,
      tongDienXung,
      tongSieuAm,
      tongHongNgoai,
      tongTap,
      tongKtXoaBopVung,
      tongOxy,
      tongCongPHCN,
      convertMoney,
      findIndex,
      tongTienCD,
      tongTienTH,
      tongTienPHCN,
      tongTienCLS,
    }
  }

}
